import React from "react";
import ReactDOM from "react-dom/client";
import LoginForm from "../header/components/LoginForm";
import elementService from "@/common/ElementService";

export default class LoginPageService {
    public init(): void {
        ReactDOM.createRoot(elementService.querySelector<HTMLDivElement>("#js-login-form-container"))
            .render(<LoginForm />);
    }
}
